const initSlideshow = () => {
	const sections = document.querySelectorAll("section.slideshow");

	if (sections.length) {
		Array.from(sections).forEach((section) => {
			const slidesLength = Array.from(
				section.querySelectorAll(".swiper-slide")
			).length;
			const swiperSlideshow = section.querySelector(".swiper-slideshow");

			const swiper = new Swiper(swiperSlideshow, {
				slidesPerView: "auto",
                centeredSlides: true, 
				roundLengths: true,
                initialSlide: 2,
				spaceBetween: 12,
				navigation: {
					nextEl: ".button-next",
					prevEl: ".button-prev",
				},

				// breakpoints: {
				// 	768: {
				// 		slidesPerView: slidesLength / 3,
				// 		spaceBetween: 20,
				// 	},
				// 	1440: {
				// 		slidesPerView: slidesLength / 2,
				// 	},
				// },
			});
		});
	}
};

export { initSlideshow };
